export function handleNavigation() {
    var menuItems = document.querySelectorAll('.menu-item-has-children');

    menuItems.forEach(function(menuItem) {
        var link = menuItem.querySelector('a');
        var subMenu = menuItem.querySelector('.sub-menu');
        var isSubMenuActive = false;

        link.addEventListener('click', function(event) {
            if (window.innerWidth <= 768) { // Adjust this value according to your mobile breakpoint
                if (!isSubMenuActive) {
                    event.preventDefault();
                    subMenu.classList.add('sub-menu--active');
                    isSubMenuActive = true;
                } else {
                    window.location.href = link.href;
                }
            }
        });

        document.addEventListener('click', function(event) {
            if (!menuItem.contains(event.target)) {
                subMenu.classList.remove('sub-menu--active');
                isSubMenuActive = false;
            }
        });
    });
}